import { ComissaoEstatisticaAgrupadaResponse } from '@/core/api/sicom-api/comissoes/estatisticas/comissao-estatistica.model';
import { resolverCorSemantica } from './chart-cores-semanticas';

export interface SegmentoRazao {
    label: string;
    total: number;
    percentual: number;
    cor: string;
}

const PALETA_NEUTRA = ['#2563eb', '#94a3b8', '#cbd5e1', '#64748b'];

export function montarSegmentosRazao(itens: ComissaoEstatisticaAgrupadaResponse[]): SegmentoRazao[] {
    const total = itens.reduce((soma, item) => soma + (Number(item.total) || 0), 0);
    return itens.map((item, indice) => {
        const valor = Number(item.total) || 0;
        return {
            label: item.descricao || item.codigo || 'Não informado',
            total: valor,
            percentual: total > 0 ? Math.round((valor / total) * 100) : 0,
            cor: resolverCorSemantica(item.codigo, item.descricao) ?? PALETA_NEUTRA[indice % PALETA_NEUTRA.length]
        };
    });
}
